export const faqData = [
  {
    id: 1,
    question: "Can MinEMI help with balance transfers for low credit scores?",
    answer:
      "Yes, MinEMI connects you with lenders catering to diverse credit profiles.",
  },
  {
    id: 2,
    question: "How much can I save with a balance transfer?",
    answer:
      "Savings depend on your outstanding debt, interest rates, and tenure. Use MinEMI’s calculator for a personalized estimate.",
  },
  {
    id: 3,
    question: " Can I consolidate multiple loans with a balance transfer?",
    answer:
      "Yes, balance transfers can consolidate multiple loans into one manageable repayment.",
  },
  {
    id: 4,
    question: " Are there hidden charges in balance transfers?",
    answer:
      "MinEMI ensures complete transparency by listing all charges upfront.",
  },
  {
    id: 5,
    question: "Can I transfer my loan to the same lender?",
    answer:
      "No, transfers are not allowed between products from the same lender.",
  },
];
